import { render, staticRenderFns } from "./responsiveGrid.component.vue?vue&type=template&id=0aea0859&"
import script from "./responsiveGrid.component.vue?vue&type=script&lang=js&"
export * from "./responsiveGrid.component.vue?vue&type=script&lang=js&"
import style0 from "./responsiveGrid.component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports